import React, { useState } from 'react';

function QuestionInput({ onSubmit, isLoading, error }) {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() && !isLoading) {
      onSubmit(inputValue.trim());
      setInputValue('');
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-lg font-mono font-bold mb-4">
          Or ask your own absurd question:
        </h3>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="text-center">
          <textarea
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="What if you could..."
            className="terminal-input w-full max-w-2xl resize-none"
            rows="3"
            disabled={isLoading}
          />
        </div>

        {error && (
          <div className="text-center">
            <p className="text-red-600 font-mono text-sm">{error}</p>
          </div>
        )}

        <div className="text-center">
          <button
            type="submit"
            disabled={!inputValue.trim() || isLoading}
            className="plain-link text-lg disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? "Thinking..." : "Ask What if AI"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default QuestionInput; 